'use strict';

function ThreePartDial() {
  this.extends = [_ComponentDataBind, _ResponsiveLayout];
  this.declaredClass = null;
  this.node = null;
  this.id = null;

  this.steps = null;
  this.currentStep = null;
  this.percent = null;
  this.type = null; // percent, steps, percent-steps

  this.duration = 1200;
  this.delay = 0;
  this.startValue = 0;

  this._classes = {
    class: 'three-part-dial',
    mod_show: 'three-part-dial--show',
    mod_percent: 'three-part-dial--percent',
    mod_steps: 'three-part-dial--steps',
    percent: 'three-part-dial__percent-container',
    svg: 'three-part-dial__percent-svg',
    middle: 'three-part-dial__middle-circle',
    inner: 'three-part-dial__inner-circle',
    content: 'three-part-dial__content',
    steps: {
      class: 'three-part-dial__steps',
      step: 'three-part-dial__steps-step',
      mod_green: 'three-part-dial__steps-step--green'
    }
  };

  this.init = function () {
    this._super();

    this.$node = $(this.node);
    this.$node.addClass(this._classes.class);
    this.$node.attr('role', 'progressbar');
    this.$node.attr('aria-valuemin', 0);

    // set a matching height
    this.updateHeight();
    this.registerResponsiveFunction(this.updateHeight.bind(this), null, null);

    // update the dial
    this.updateDials();
    this.$node.addClass(this._classes.mod_show);

    this.onDataBindUpdate('steps', this.updateDials.bind(this));
    this.onDataBindUpdate('currentStep', this.updateDials.bind(this));
    this.onDataBindUpdate('percent', this.updateDials.bind(this));
    this.onDataBindUpdate('type', this.updateDials.bind(this));
  };

  this.initAllReady = function () {};
  this.destroy = function () {
    this._super();
  };

  this.updateDials = function () {
    this.$node.children().not('.' + this._classes.content).remove();

    this.$middleCircle = $('<div></div>');
    this.$middleCircle.addClass(this._classes.middle);

    this.$innerCircle = $('<div></div>');
    this.$innerCircle.addClass(this._classes.inner);

    if (this.type === 'percent' || this.type === 'percent-steps') {
      this.$node.addClass(this._classes.mod_percent);
      this.$node.attr('aria-valuemax', 100);
      this.$node.attr('aria-valuenow', this.percent);

      this.$percent = $('<div></div>');
      this.$percent.addClass(this._classes.percent);

      // add svg progress dial
      this.$svg = $('<svg class="" viewBox="0 0 294 294"><g transform="translate(-37.000000, -36.000000)"><path d="M210.398524,326.008858 C239.598373,320.646358 265.723254,306.528112 285.933732,286.485552 C312.243525,260.394355 328.530438,224.263483 328.530438,184.339317 C328.530438,104.778858 263.851687,40.2823638 184.066404,40.2823638 C104.281121,40.2823638 39.6023694,104.778858 39.6023694,184.339317 C39.6023694,220.138993 52.6979656,252.888647 74.3728469,278.084696" transform="translate(184.066404, 183.145611) rotate(-19.500000) translate(-184.066404, -183.145611) "></path><path d="M210.398524,326.008858 C239.598373,320.646358 265.723254,306.528112 285.933732,286.485552 C312.243525,260.394355 328.530438,224.263483 328.530438,184.339317 C328.530438,104.778858 263.851687,40.2823638 184.066404,40.2823638 C104.281121,40.2823638 39.6023694,104.778858 39.6023694,184.339317 C39.6023694,220.138993 52.6979656,252.888647 74.3728469,278.084696" transform="translate(184.066404, 183.145611) rotate(-19.500000) translate(-184.066404, -183.145611) "></path></g></svg>');
      this.$svg.attr('class', this._classes.svg);
      this.$greenPath = this.$svg.find('path').eq(1);
      this.$percent.append(this.$svg);

      // append progress html to node
      this.$node.append(this.$percent);
    }

    if (this.type === 'steps' || this.type === 'percent-steps') {
      this.$node.addClass(this._classes.mod_steps);
      this.$node.attr('aria-valuemax', this.steps);
      this.$node.attr('aria-valuenow', this.currentStep);

      this.$steps = $('<div></div>');
      this.$steps.addClass(this._classes.steps.class);

      // min rotation -60
      // max rotation 240
      // total rotation size: 300

      for (var i = 0; i < this.steps; i++) {
        var $step = $('<div></div>');
        var rotation = 300 / (this.steps - 1) * i - 60;
        $step.addClass(this._classes.steps.step);
        if (i < this.currentStep) $step.addClass(this._classes.steps.mod_green);

        $step.css({
          transform: 'translateY(-50%) rotate(' + rotation + 'deg)'
        });

        this.$steps.append($step);
      }

      this.$node.append(this.$steps);
    }

    this.$node.append(this.$middleCircle);
    this.$node.append(this.$innerCircle);
    this._animateDelay = setTimeout(this.animateDial.bind(this), this.delay);
  };

  this.animateDial = function () {
    if (this.type === 'percent' || this.type === 'percent-steps') {
      $({ value: this.startValue }).animate({ value: this.percent }, {
        queue: false,
        easing: 'easeOutCubic',
        duration: this.duration,
        step: function (value) {
          // min range 756
          // max range 1512
          this._barProgress = 756 / 100 * value + 757;
          this._dialRotation = 300 / 100 * value - 60;

          // round up any fractional value over 0/under 1 so the dial shows a progress indicator
          if (this._barProgress > 757 && this._barProgress < 758) this._barProgress = 758;

          this.$greenPath.css({
            'stroke-dashoffset': this._barProgress
          });

          this.$innerCircle.css({
            transform: 'translateX(-50%) translateY(-50%) rotate(' + this._dialRotation + 'deg)'
          });
        }.bind(this),

        complete: function (value) {
          this.startValue = this.percent;
        }.bind(this)
      });
    } else if (this.type === 'steps') {
      $({ value: this.startValue }).animate({ value: this.currentStep }, {
        queue: false,
        easing: 'easeOutCubic',
        duration: this.duration,
        step: function (value) {
          if (value == 0) {
            value = 1;
          } else if (value == -1) {
            value = this.steps;
          }
          this._dialRotation = 300 / (this.steps - 1) * (value - 1) - 60;

          this.$middleCircle.css({
            transform: 'translateX(-50%) translateY(-50%) rotate(' + this._dialRotation + 'deg)'
          });
        }.bind(this),

        complete: function () {
          this.startValue = this.currentStep;
        }.bind(this)
      });
    }
  };

  this.updateHeight = function () {
    this.$node.css({ height: this.$node.width() });
  };
}